export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 64;
export const EDUCATION_CATEGORY_ID = "60fc4868f485d8dd91ed321e";
export const APPROVED_DOCUMENT_STATUS = "approved";
export const UPLOAD_DOC_MAX_SIZE = 1048576; // 1MB to Bytes
export const UPLOAD_DOC_MAX_SIZE_MB = 1;
export const UPLOAD_DOC_FILE_TYPE_ERROR_MSG = "The system accept images only";
export const SUPORT_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/tiff",
  "image/webp",
  "image/bmp",
  "image/gif",
  "application/pdf",
];
export const IMAGES_TYPES = ["jpeg", "png", "tiff", "webp", "bmp", "gif"];
export const TimeZone = "Africa/Kigali";
